import { Link } from 'react-router-dom';
import { hotTags } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20entertainment%20industry%20scene%2C%20warm%20amber%20spotlight%20on%20dark%20stage%2C%20mysterious%20atmosphere%20with%20theater%20curtains%2C%20gossip%20and%20scandal%20theme%2C%20paparazzi%20flash%20effects%2C%20golden%20warm%20tones%2C%20high%20contrast%20dramatic%20lighting%2C%20no%20text%20no%20people%2C%20abstract%20editorial%20style&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape"
          alt="91吃瓜网 - 明星网红黑料每日大赛"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col justify-center px-4 md:px-6">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-500/30 mb-6">
            <i className="ri-fire-line text-accent-500 text-sm"></i>
            <span className="text-xs text-accent-500 font-medium">实时更新中</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            明星网红黑料
            <br />
            每日大赛在线看
          </h1>

          <p className="text-base md:text-lg text-background-50/70 max-w-xl mb-6 leading-relaxed">
            91吃瓜网实时追踪网红明星最新黑料，娱乐圈爆料、社会热点大瓜第一时间更新，吃瓜群众的必刷入口，想看最新塌房现场就别错过。
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-8">
            <Link
              to="/category/meiri-dasai"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-950 font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap"
            >
              立即吃瓜
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/wanghong-heiliao"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/30 text-background-50 text-sm hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap"
            >
              网红黑料
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-50/50 whitespace-nowrap">热门标签：</span>
            {hotTags.slice(0, 5).map((tag, idx) => (
              <Link
                key={idx}
                to={`/category/mingxing-tafang`}
                className="px-2.5 py-1 rounded-full text-xs bg-background-50/10 text-background-50/70 hover:bg-background-50/20 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}